<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Groups"
                    />
                    <!-- End Title -->
                </div>
            </div>

            <app-box :loading="loading" :initial="loading">
                <app-field-text 
                    :required="true"
                    label="Name" 
                    v-model="fields.name" 
                    :error="errors.name"
                />

                <app-permissions :params="params" v-model="fields.permissions" />

                <div slot="footer">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'groups.home' })">
                        Cancel
                    </app-button>
                </div>
            </app-box>
        </app-content>

        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';

    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';

    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import Permissions from '@/components/Permissions';
    import TextField from '@/components/fields/inputs/Text';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'groups.edit',

        props: {
            id: {
                type: String,
                required: true
            }
        },

        data: () => ({
            loading: true,
            group: null,
            fields: {
                name: '',
                permissions: {}
            },
            params: {},
            errors: {}
        }),

        mixins: [ ValidationErrors ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-field-text': TextField,
            'app-permissions': Permissions
        },

        mounted() {
            this.get().then(response => {
                if(typeof this.group !== null && Object.keys(this.group).length > 0) {
                    this.fields.name = this.group.name;
                    
                    if(typeof this.group.permissions === 'object') {
                        this.params = this.group.permissions;
                    }
                }
            }).then(response => {
                this.loading = false;
            });
        },

        methods: {
            get() {
                return Api.request('get', `groups/edit/${this.id}`).then(({ data }) => {
                    this.group = data.group;
                });
            },

            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `groups/update/${this.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, { 
                            type: "success", 
                            position: "bottom-right", 
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'groups.home'
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/groups/Edit.vue